import {
  PERMISSION_KEYS,
  hasAdminDashboardPermission,
} from './admin-dashboard-permissions';

export default (user) => (
  hasAdminDashboardPermission(user, PERMISSION_KEYS.ENGINEERING_SUPPORT)
);
